import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CookiesService {
  constructor(@Inject(DOCUMENT) private readonly document: Document) {}

  set(key: string, value: string, ttlSeconds?: number): void {
    if (!this.document) {
      return;
    }

    const encoded = encodeURIComponent(value);
    let cookie = `${key}=${encoded}; path=/; SameSite=Lax`;

    if (ttlSeconds && Number.isFinite(ttlSeconds)) {
      cookie += `; Max-Age=${Math.max(0, Math.trunc(ttlSeconds))}`;
    }

    if (this.document.defaultView?.location.protocol === 'https:') {
      cookie += '; Secure';
    }

    this.document.cookie = cookie;
  }

  get(key: string): string | null {
    if (!this.document?.cookie) {
      return null;
    }

    const cookies = this.document.cookie.split(';');
    for (const entry of cookies) {
      const [rawName, ...rest] = entry.split('=');
      if (!rawName) {
        continue;
      }

      if (rawName.trim() === key) {
        return decodeURIComponent(rest.join('='));
      }
    }

    return null;
  }

  delete(key: string): void {
    if (!this.document) {
      return;
    }

    this.document.cookie = `${key}=; path=/; Max-Age=0; SameSite=Lax`;
  }
}
